import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDMY } from "../../utils/date";
import { motion } from "framer-motion";
import "./News.css";

const NewsReadPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { newsData } = location.state || {};

  return (
    <motion.div
      className="nr-wrap"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
    >
      <div className="nr-top">
        <button className="nr-back" onClick={() => navigate(-1)}>
          <i className="bx bx-arrow-back"></i> Back
        </button>
        <span className="nr-meta">
          <i className="bx bx-calendar"></i> {formatDMY(newsData?.created_at)}
        </span>
      </div>

      <div className="nr-card">
        <h1 className="nr-title">{newsData?.title || "News"}</h1>

        <div className="nr-hero">
          <img
            src={
              newsData?.image
                ? newsData?.image.replace("/thumb", "")
                : "assets/images/dummy-news-img.jpeg"
            }
            alt={newsData?.title}
            loading="lazy"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "assets/images/dummy-news-img.jpeg";
            }}
          />
        </div>

        <div
          className="nr-content"
          dangerouslySetInnerHTML={{ __html: newsData?.description }}
        />
      </div>
    </motion.div>
  );
};

export default NewsReadPage;
